module.exports = __webpack_public_path__ + "static/img/img_2.da062eb0.jpg";